import React from 'react';

// onEdit / onDelete are omitted for people who can only read the directory (managers).
export default function VendorCard({ vendor, onEdit, onDelete }) {
  return (
    <div className="vendor-card" onClick={() => onEdit && onEdit(vendor)}>
      <div className="vendor-body">
        <div className="vendor-name">{vendor.name}</div>
        <div className="vendor-meta">
          {vendor.specialty && (
            <span className="tag tag-specialty">{vendor.specialty}</span>
          )}
        </div>
        <div className="vendor-contact">
          {vendor.phone && <span>Phone: {vendor.phone}</span>}
          {vendor.email && <span>Email: {vendor.email}</span>}
        </div>
        {vendor.notes && (
          <div className="vendor-notes">{vendor.notes}</div>
        )}
      </div>

      {onEdit && (
        <div className="task-actions" onClick={e => e.stopPropagation()}>
          <button className="icon-btn" onClick={() => onEdit(vendor)} title="Edit">Edit</button>
          <button className="icon-btn delete" onClick={() => onDelete(vendor.id)} title="Delete">Delete</button>
        </div>
      )}
    </div>
  );
}
